import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-club-add-dialog',
  templateUrl: './club-add-dialog.component.html',
  styleUrls: ['./club-add-dialog.component.scss']
})
export class ClubAddDialogComponent implements OnChanges {
  @Input() club: any = null;
  @Input() existingClubs: any[] = [];
  @Output() save = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<void>();

  name = '';
  code = '';
  isSaving = false;
  formError = '';

  constructor(private http: HttpClient) {}

  get isEditMode(): boolean {
    return !!this.club;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['club']) {
      this.name = this.club?.name || '';
      this.code = this.club?.code || '';
      this.formError = '';
    }
  }

  onSave(): void {
    const name = this.name.trim();
    if (!name || this.isSaving) {
      this.formError = 'Vnesite ime kluba.';
      return;
    }
    if (!this.code.trim()) {
      this.formError = 'Vnesite kratico kluba.';
      return;
    }

    this.isSaving = true;
    this.formError = '';
    const request = this.isEditMode
      ? this.http.post(`https://testapi.ovh/api/strelstvo/clubs/${this.club.club_id}`, { name, code: this.code.trim() }, this.requestOptions())
      : this.http.post('https://testapi.ovh/api/strelstvo/clubs', { name, code: this.code.trim() }, this.requestOptions());

    request.subscribe({
      next: response => {
        this.isSaving = false;
        this.save.emit(response);
      },
      error: error => {
        this.isSaving = false;
        this.formError = error.error?.error || 'Napaka pri shranjevanju kluba.';
      }
    });
  }

  onCancel(): void {
    if (!this.isSaving) {
      this.cancel.emit();
    }
  }

  private requestOptions(): { headers: HttpHeaders; params: HttpParams } {
    const token = localStorage.getItem('access_token');
    const unitId = localStorage.getItem('unit_id');
    return {
      headers: token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders(),
      params: unitId ? new HttpParams().set('unit_id', unitId) : new HttpParams()
    };
  }
}
